import React from 'react';
import { useTheme } from '../context/ThemeContext';
type Variant = 'light' | 'dark';
/**
 * Dynamic Organization Logo (keeps legacy name for backward compatibility).
 * Reads logo URL and org name from ThemeContext.
 * - variant="dark" (default) → white/silver inverted treatment for dark backgrounds
 * - variant="light" → native colors for bright backgrounds
 */
export function SharjahPoliceEmblem({
  variant = 'dark'
}: {
  variant?: Variant;
}) {
  const {
    theme
  } = useTheme();
  const isDark = variant === 'dark';
  return <div className="flex items-center" dir="rtl" data-id="element-90">
      <img src={theme.logoUrl} alt={`${theme.orgNameAr} — ${theme.orgNameEn}`} className="h-[clamp(2.75rem,6vh,4.25rem)] w-auto select-none" style={{
      filter: isDark ? 'brightness(0) invert(1) drop-shadow(0 0 18px rgba(53,192,200,0.25))' : 'drop-shadow(0 4px 18px rgba(14,93,85,0.18))',
      opacity: isDark ? 0.9 : 1
    }} draggable={false} data-id="element-91" />
    </div>;
}